import { Link } from 'react-router-dom'
import { Clock } from 'lucide-react'
import type { BlogListItem } from '../../lib/api/blog'

export function BlogCard({ post }: { post: BlogListItem }) {
  return (
    <Link
      to={`/blog/${post.slug}`}
      className="group flex flex-col bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-md hover:border-gray-200 transition-all overflow-hidden"
    >
      <div className="aspect-[16/9] w-full overflow-hidden" style={post.heroImageUrl ? undefined : { background: post.heroGradient }}>
        {post.heroImageUrl && (
          <img
            src={post.heroThumbUrl || post.heroImageUrl}
            alt={post.title}
            width={640}
            height={360}
            loading="lazy"
            className="h-full w-full object-cover group-hover:scale-[1.02] transition-transform duration-300"
          />
        )}
      </div>
      <div className="p-5 flex flex-col flex-1">
        <span className="text-xs font-semibold uppercase tracking-wide text-gold-600">{post.category}</span>
        <h2 className="font-bold text-gray-900 mt-1 leading-snug group-hover:text-gold-700 transition-colors">{post.title}</h2>
        <p className="text-sm text-gray-500 mt-2 flex-1">{post.excerpt}</p>
        <div className="flex items-center gap-1.5 text-xs text-gray-500 mt-3">
          <Clock className="h-3.5 w-3.5" /> {post.readingMinutes} min read
        </div>
      </div>
    </Link>
  )
}
